/* eslint-disable react/no-danger */
import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import urls from '../../constants/urls.js';
import articleTypes from '../../constants/articleTypes';

const DiscoverSummaryItem = ({item, index}) => { 

    const getLink = () => {
        return `/Discover/${item.Link}`;
    };

    const getIntroRaw = () => {
        return {__html: item.Intro};
    };

    const getImage = (params) => {
        return urls.USER_IMAGES_BASE_URL + item.ImageUrl + (params || '');
    };

    const getDateString = () => {
        let date = new Date(item.Date);
        return date.toLocaleDateString('en-GB', { year: 'numeric', month: 'short', day: 'numeric' });
    };

    return (
        <div className={`demo-card-wide mdl-card mdl-shadow--2dp ${index == 1 ? 'grid-sizer' : ''}`}>
            <div className="mdl-card__title">
                <Link to={getLink()}>
                    {
                        item.Sections.map(section =>
                            <p key={section} className="type">{section.toUpperCase()}</p>
                        )
                    }
                    <img src={getImage("?width=300&quality=80&mode=crop&scale=both&format=jpg")} alt={item.Title} />
                    <div className="mdl-card__song">
                        <h2 className="mdl-card__title-text">{item.Title}</h2>
                        {/*<p className="date">{`${item.AuthorDisplayName} · ${getDateString()}`}</p>*/}
                    </div>
                </Link>
            </div>
            <div className="mdl-card__supporting-text">
                <p className="intro" dangerouslySetInnerHTML={getIntroRaw()} />
                <br />
                {
                    item.Tags.map(tag =>
                        <a key={tag} href={null} className="sect transition" style={{marginRight: '2px'}}>{tag}</a>
                    )
                }
            </div>
            <div className="mdl-card__actions mdl-card--border">
                <Link to={getLink()} className="mdl-button mdl-button--colored mdl-button__orange mdl-js-button mdl-js-ripple-effect">
                    Continue Reading
                </Link>
            </div>
        </div>
        /*if (index == 2)
        {
            <div className="demo-card-wide mdl-card mdl-shadow--2dp ad">
                <div className="content-side-2" />
            </div>
        }*/
    );
};

export default DiscoverSummaryItem;

DiscoverSummaryItem.propTypes = {
    item: PropTypes.object,
    index: PropTypes.number
};